import { PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { DiiaStatuses, TDiiaInitializeResponse, TDiiaSignInStore } from '../types.ts';
import { errorMessages } from '~/constants/errorMessages.ts';
import { TErrorResponse } from '../../types.ts';

export const initializeFulfilled = (
  state: TDiiaSignInStore,
  action: PayloadAction<TDiiaInitializeResponse>
) => {
  state.deepLink = action.payload.deeplink;
  state.dynamicLink = action.payload.dynamicLink;
  state.requestId = action.payload.requestId;
  state.loading = false;
  state.error = null;
  state.status = '';
};

export const initializePending = (state: TDiiaSignInStore) => {
  state.loading = true;
  state.deepLink = '';
  state.dynamicLink = '';
  state.requestId = '';
};

export const diiaPending = (state: TDiiaSignInStore) => {
  state.loading = true;
  state.error = '';
};

export const diiaError = (
  state: TDiiaSignInStore,
  action: { error: SerializedError; payload?: TErrorResponse | unknown }
) => {
  state.loading = false;
  if ((action.payload as TErrorResponse)?.errorCode?.toString() === '1000') {
    state.error = errorMessages.SERVICE_UNAVAILABLE;
  }
  if (action.error.name === 'AbortError') {
    state.error = null;
  } else {
    state.error = (action.payload as TErrorResponse)?.message || errorMessages.SERVICE_UNAVAILABLE;
  }
};

export const setSignStatus = (
  state: TDiiaSignInStore,
  action: PayloadAction<{ status: string | null }>
) => {
  state.loading = false;
  state.error = null;
  state.status = action.payload.status || '';
};

export const diiaFinalStatusError = (
  state: TDiiaSignInStore,
  action: { error: SerializedError; payload?: TErrorResponse | unknown }
) => {
  state.loading = false;
  state.error = (action.payload as TErrorResponse)?.message || errorMessages.SERVICE_UNAVAILABLE;
  state.status = DiiaStatuses.rejected;
};
